import { requestService as api } from "../Request.service"  

const API_URL = {
  API_MANAGE: `/ERP/bom/manage.php`,
  API_SEARCH: `/ERP/bom/search.php`,
};



const BomService = () => { 
 
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  // const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (product_code,type) => api.get(`${API_URL.API_MANAGE}?product_code=${product_code}&type=${type}`);
  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});
  
  return {
    create,
    update,
    // deleted,
    get,
    search,
  };
};

export default BomService;
